import { useMemo } from "react";
import { getJwtRoleSlug } from "../../../public/utils/jwtRole";
import { getStoredAuthRole } from "../../../public/utils/authSession";
import { getAuthItem } from "../../../public/utils/authStorage";
import { usePropertyAssetRolePermissions } from "../hooks/usePropertyAssetRolePermissions";
import {
  buildPropertyAssetPermissions,
  buildPropertyAssetPermissionsForScreen,
} from "./propertyAssetPermissions";

function resolveRoleSlug() {
  return (
    getJwtRoleSlug(getAuthItem("jwt_token")) ||
    getStoredAuthRole() ||
    ""
  );
}

export function usePropertyAssetRole(screenSlug = null) {
  const sessionRoleSlug = useMemo(() => resolveRoleSlug(), []);

  const {
    permissions,
    roleSlug: apiRoleSlug,
    loading: permissionsLoading,
    error: permissionsError,
  } = usePropertyAssetRolePermissions(Boolean(sessionRoleSlug));

  const roleSlug = apiRoleSlug || sessionRoleSlug;

  const perms = useMemo(() => {
    if (screenSlug) {
      return buildPropertyAssetPermissionsForScreen(permissions, roleSlug, screenSlug);
    }
    return buildPropertyAssetPermissions(permissions);
  }, [permissions, roleSlug, screenSlug]);

  return {
    roleSlug,
    permissionsLoading,
    permissionsError,
    isAdmin: perms.isAdmin,
    canView: perms.canView,
    canCreate: perms.canCreate,
    canEdit: perms.canEdit,
    canDelete: perms.canDelete,
    canManageMasters: perms.canManageMasters,
    canDeleteMasters: perms.canDeleteMasters,
    canExport: perms.canExport,
    limitedEdit: perms.limitedEdit,
  };
}
